var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { createVirtualBackgroundEffect } from '../stream-effects/virtual-background';
import { BACKGROUND_ENABLED, SET_VIRTUAL_BACKGROUND, VIRTUAL_BACKGROUND_TRACK_CHANGED } from './actionTypes';
import logger from './logger';
/**
 * Signals the local participant activate the virtual background video or not.
 *
 * @param {Object} options - Represents the virtual background set options.
 * @param {Object} jitsiTrack - Represents the jitsi track that will have backgraund effect applied.
 * @returns {Promise}
 */
export function toggleBackgroundEffect(options, jitsiTrack) {
    return function (dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            yield dispatch(backgroundEnabled(options.enabled));
            yield dispatch(setVirtualBackground(options));
            const state = getState();
            const virtualBackground = state['features/virtual-background'];
            if (jitsiTrack) {
                try {
                    if (options.enabled) {
                        yield jitsiTrack.setEffect(yield createVirtualBackgroundEffect(virtualBackground, dispatch));
                    }
                    else {
                        yield jitsiTrack.setEffect(undefined);
                        dispatch(backgroundEnabled(false));
                    }
                }
                catch (error) {
                    dispatch(backgroundEnabled(false));
                    logger.error('Error on apply background effect:', error);
                }
            }
        });
    };
}
/**
 * Sets the selected virtual background image object.
 *
 * @param {Object} options - Represents the virtual background set options.
 * @returns {{
 *     type: SET_VIRTUAL_BACKGROUND,
 *     virtualSource: string,
 *     blurValue: number,
 *     type: string,
 * }}
 */
export function setVirtualBackground(options) {
    return {
        type: SET_VIRTUAL_BACKGROUND,
        virtualSource: options === null || options === void 0 ? void 0 : options.url,
        blurValue: options === null || options === void 0 ? void 0 : options.blurValue,
        backgroundType: options === null || options === void 0 ? void 0 : options.backgroundType,
        selectedThumbnail: options === null || options === void 0 ? void 0 : options.selectedThumbnail
    };
}
/**
 * Signals the local participant that the background effect has been enabled.
 *
 * @param {boolean} backgroundEffectEnabled - Indicate if virtual background effect is activated.
 * @returns {{
 *      type: BACKGROUND_ENABLED,
 *      backgroundEffectEnabled: boolean
 * }}
 */
export function backgroundEnabled(backgroundEffectEnabled) {
    return {
        type: BACKGROUND_ENABLED,
        backgroundEffectEnabled
    };
}
/**
 * Signals if the local track was changed due to a changes of the virtual background.
 *
 * @returns {{
 *    type: VIRTUAL_BACKGROUND_TRACK_CHANGED
 * }}
 */
export function virtualBackgroundTrackChanged() {
    return {
        type: VIRTUAL_BACKGROUND_TRACK_CHANGED
    };
}
